import type { Listing } from "@/types"

export const LISTING_TYPE_LABELS: Record<Listing["listing_type"], string> = {
  sale: "For sale",
  long_let: "Long let",
  short_let: "Short let",
  holiday_let: "Holiday let",
}

export const STATUS_VARIANTS: Record<Listing["status"], "default" | "secondary" | "outline"> = {
  draft: "secondary",
  active: "default",
  archived: "outline",
}
